import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { initilizeMsal, msalConfig } from './azure/authConfig';
import { PublicClientApplication, InteractionType } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';

export const msalInstance = new PublicClientApplication(msalConfig);
initilizeMsal(msalInstance);

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

root.render(
    <MsalProvider instance={msalInstance}>
        <BrowserRouter basename={baseUrl}>
            <App />
        </BrowserRouter>
    </MsalProvider>
);

/**
 * @author:Sandeep Sirohi
 * @description: Solution of basename issue in develoment environment. This will now redirect to proper page automatically.
 */
if (process.env.NODE_ENV === 'development') {
    if (window.location.pathname === '/') {
        window.location.assign('/app/website/');
    }
}
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();


